import { cn } from '@/lib/utils'

interface DrawToolbarProps {
  tool: 'pen' | 'erase'
  setTool: (tool: 'pen' | 'erase') => void
  color: string
  setColor: (color: string) => void
  thickness: number
  setThickness: (thickness: number) => void
  colors?: string[]
}

const DEFAULT_COLORS = ['#D93025', '#C4D44A', '#ffffff', '#111111', '#C8A84B']

/**
 * Toolbar de desenho compartilhada entre FotoAnnotate e CapturaDrawCanvas.
 * Caneta/borracha + espessura + paleta de cores.
 */
export default function DrawToolbar({
  tool, setTool,
  color, setColor,
  thickness, setThickness,
  colors = DEFAULT_COLORS,
}: DrawToolbarProps) {
  return (
    <div className="flex-shrink-0 flex items-center justify-center gap-1.5 px-3 py-2 bg-[#1a1a1a] border-b border-white/[0.08]">
      {/* Caneta / Borracha */}
      <button
        onClick={() => setTool('pen')}
        className={cn(
          'w-9 h-9 flex items-center justify-center rounded-lg border-none cursor-pointer transition-colors',
          tool === 'pen' ? 'bg-hero/20' : 'bg-white/[0.05]'
        )}
        title="Caneta"
      >
        <span className={cn('material-symbols-outlined text-lg', tool === 'pen' ? 'text-hero' : 'text-[#888]')}>edit</span>
      </button>
      <button
        onClick={() => setTool('erase')}
        className={cn(
          'w-9 h-9 flex items-center justify-center rounded-lg border-none cursor-pointer transition-colors',
          tool === 'erase' ? 'bg-hero/20' : 'bg-white/[0.05]'
        )}
        title="Borracha"
      >
        <span className={cn('material-symbols-outlined text-lg', tool === 'erase' ? 'text-hero' : 'text-[#888]')}>ink_eraser</span>
      </button>

      {/* Separador */}
      <div className="w-px h-5 mx-1 bg-white/[0.12]" />

      {/* Espessura */}
      {[2, 4, 8].map(t => (
        <button
          key={t}
          onClick={() => setThickness(t)}
          className={cn(
            'w-9 h-9 flex items-center justify-center rounded-lg border-none cursor-pointer',
            thickness === t ? 'bg-white/10' : 'bg-transparent'
          )}
        >
          <span
            className="block rounded-full"
            style={{
              width: t + 2,
              height: t + 2,
              background: thickness === t ? '#f0f0f0' : '#666',
            }}
          />
        </button>
      ))}

      {/* Separador */}
      <div className="w-px h-5 mx-1 bg-white/[0.12]" />

      {/* Cores */}
      {colors.map(c => (
        <button
          key={c}
          onClick={() => { setColor(c); setTool('pen') }}
          className={cn(
            'w-7 h-7 rounded-full border-2 border-none cursor-pointer shrink-0',
            color === c && tool === 'pen' ? 'border-hero' : 'border-white/20'
          )}
          style={{
            background: c,
            borderStyle: 'solid',
            borderWidth: 2,
            borderColor: color === c && tool === 'pen' ? 'var(--color-hero)' : 'rgba(255,255,255,0.20)',
          }}
        />
      ))}
    </div>
  )
}
